import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../app/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_b3e53afc from 'nuxt_plugin_plugin_b3e53afc' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_pluginclient_51361cfe from 'nuxt_plugin_pluginclient_51361cfe' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_9220e2f4 from 'nuxt_plugin_pluginserver_9220e2f4' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_axios_77447ed0 from 'nuxt_plugin_axios_77447ed0' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_core_926f68da from 'nuxt_plugin_core_926f68da' // Source: ../../../app/plugins/core (mode: 'all')
import nuxt_plugin_bugsnag_6b5683c1 from 'nuxt_plugin_bugsnag_6b5683c1' // Source: ../../../app/plugins/bugsnag (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../../../app/plugins/axios (mode: 'all')
import nuxt_plugin_consola_d33b5642 from 'nuxt_plugin_consola_d33b5642' // Source: ../../../app/plugins/consola (mode: 'all')
import nuxt_plugin_vueapiquery_8652834c from 'nuxt_plugin_vueapiquery_8652834c' // Source: ../../../app/plugins/vue-api-query (mode: 'all')
import nuxt_plugin_vuelidate_0f19c03d from 'nuxt_plugin_vuelidate_0f19c03d' // Source: ../../../app/plugins/vuelidate (mode: 'all')
import nuxt_plugin_i18n_926bd3dc from 'nuxt_plugin_i18n_926bd3dc' // Source: ../../../app/plugins/i18n (mode: 'all')
import nuxt_plugin_vue2filters_6725aae4 from 'nuxt_plugin_vue2filters_6725aae4' // Source: ../../../app/plugins/vue2-filters (mode: 'all')
import nuxt_plugin_vueclipboard_914d1eca from 'nuxt_plugin_vueclipboard_914d1eca' // Source: ../../../app/plugins/vue-clipboard (mode: 'all')
import nuxt_plugin_icons_229035a6 from 'nuxt_plugin_icons_229035a6' // Source: ../../../app/plugins/icons (mode: 'all')
import nuxt_plugin_routes_3f7e063e from 'nuxt_plugin_routes_3f7e063e' // Source: ../../../app/plugins/routes (mode: 'all')
import nuxt_plugin_toast_233078b3 from 'nuxt_plugin_toast_233078b3' // Source: ../../../app/plugins/toast (mode: 'all')
import nuxt_plugin_index_8de7eac2 from 'nuxt_plugin_index_8de7eac2' // Source: ../../../app/store/index (mode: 'all')
import nuxt_plugin_modernizr_2916226e from 'nuxt_plugin_modernizr_2916226e' // Source: ../../../app/plugins/modernizr (mode: 'all')
import nuxt_plugin_polyfill_793e4943 from 'nuxt_plugin_polyfill_793e4943' // Source: ../../../app/plugins/polyfill (mode: 'all')
import nuxt_plugin_laravelecho_2c4d56a6 from 'nuxt_plugin_laravelecho_2c4d56a6' // Source: ../../../app/plugins/laravel-echo (mode: 'all')
import nuxt_plugin_gtm_caeab2a8 from 'nuxt_plugin_gtm_caeab2a8' // Source: ../../../app/plugins/gtm (mode: 'all')
import nuxt_plugin_kactivity_64b222b4 from 'nuxt_plugin_kactivity_64b222b4' // Source: ../../../app/plugins/k-activity.client (mode: 'client')
import nuxt_plugin_errorhandler_25db1b11 from 'nuxt_plugin_errorhandler_25db1b11' // Source: ../../../app/plugins/error-handler (mode: 'all')
import nuxt_plugin_vuetify_e5914fcc from 'nuxt_plugin_vuetify_e5914fcc' // Source: ../../../app/plugins/vuetify (mode: 'all')
import nuxt_plugin_plugin_1c07fbd4 from 'nuxt_plugin_plugin_1c07fbd4' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../../../app/plugins/auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: (vue) => {
  let title = 'A better knowledge sharing experience over video | Kintell';
  let description = 'Teach, consult, mentor, learn, schedule meetings and change the world with Kintell – the simple and powerful way to share knowledge over video.';
  let image = 'https://assets.kintell.com/social/default-og.png';

  const extraMeta = [];

  // when rendering out the page on the frontend we will inject our meta data from the i18n page details
  if (typeof window !== 'undefined' && typeof vue !== 'undefined' && !vue.ssr) {
    const pages = vue.$td('app.pages');
    let page;
    for (const p in pages) {
      if (pages[p].url === vue.$route.path) {
        page = pages[p];
      }
    }
    // no every page will be configured
    if (page) {
      if (page.title || page.metaTitle) {
        title = page.metaTitle ?? page.title;
      }
      if (page.description) {
        description = page.description;
      }
      if (page.image) {
        image = page.image.replace('~', '/');
      }
      if (page.noindex) {
        extraMeta.push({ name: 'robots', content: 'noindex' });
      }
    }
    // re-rendered on page load, otherwise we don't have access to the path being rendered
    extraMeta.push({
      hid: 'og:url',
      property: 'og:url',
      content: 'https://kintell.com' + vue.$route.path });
  }

  const script = [
  { src: 'https://js.stripe.com/v3/', async: true, defer: true, body: true }];

  const links = [
  { rel: 'icon', type: 'image/x-icon', href: process.env.NODE_ENV === 'production' ? '/favicon.png' : '/favicon-uat.png' },
  {
    rel: 'preconnect',
    href: 'https://cds.taboola.com',
    crossorigin: true },

  {
    rel: 'preload',
    href: '/fonts/Pangea-SemiBold.woff2',
    as: 'font' },

  {
    rel: 'preload',
    href: '/fonts/Pangea-Regular.woff2',
    as: 'font' }];

  if (typeof window !== 'undefined' && typeof vue !== 'undefined' && !vue.ssr) {
    const path = vue.$route.path.startsWith('/') ? vue.$route.path : '/' + vue.$route.path;
    links.push({ rel: 'canonical', href: process.env.APP_URL + path });
  }

  return {
    titleTemplate: '%s | Kintell',
    title,
    htmlAttrs: {
      lang: 'en' },

    meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
    { hid: 'description', name: 'description', content: description },
    { hid: 'image', name: 'image', content: image },
    { hid: 'og:title', property: 'og:title', content: title },
    { hid: 'og:description', property: 'og:description', content: description },
    { hid: 'og:image', property: 'og:image', content: image },
    ...extraMeta],

    link: links,
    script,
    __dangerouslyDisableSanitizers: ['link'],
    __dangerouslyDisableSanitizersByTagID: {
      'org-schema': ['innerHTML'],
      'site-nav-schema': ['innerHTML'],
      'website-schema': ['innerHTML'],
      'article-schema': ['innerHTML'],
      'advisor-schema': ['innerHTML'],
      'faq-schema': ['innerHTML'] } };
},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_b3e53afc === 'function') {
    await nuxt_plugin_plugin_b3e53afc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_51361cfe === 'function') {
    await nuxt_plugin_pluginclient_51361cfe(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_9220e2f4 === 'function') {
    await nuxt_plugin_pluginserver_9220e2f4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_77447ed0 === 'function') {
    await nuxt_plugin_axios_77447ed0(app.context, inject)
  }

  if (typeof nuxt_plugin_core_926f68da === 'function') {
    await nuxt_plugin_core_926f68da(app.context, inject)
  }

  if (typeof nuxt_plugin_bugsnag_6b5683c1 === 'function') {
    await nuxt_plugin_bugsnag_6b5683c1(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_consola_d33b5642 === 'function') {
    await nuxt_plugin_consola_d33b5642(app.context, inject)
  }

  if (typeof nuxt_plugin_vueapiquery_8652834c === 'function') {
    await nuxt_plugin_vueapiquery_8652834c(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_0f19c03d === 'function') {
    await nuxt_plugin_vuelidate_0f19c03d(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_926bd3dc === 'function') {
    await nuxt_plugin_i18n_926bd3dc(app.context, inject)
  }

  if (typeof nuxt_plugin_vue2filters_6725aae4 === 'function') {
    await nuxt_plugin_vue2filters_6725aae4(app.context, inject)
  }

  if (typeof nuxt_plugin_vueclipboard_914d1eca === 'function') {
    await nuxt_plugin_vueclipboard_914d1eca(app.context, inject)
  }

  if (typeof nuxt_plugin_icons_229035a6 === 'function') {
    await nuxt_plugin_icons_229035a6(app.context, inject)
  }

  if (typeof nuxt_plugin_routes_3f7e063e === 'function') {
    await nuxt_plugin_routes_3f7e063e(app.context, inject)
  }

  if (typeof nuxt_plugin_toast_233078b3 === 'function') {
    await nuxt_plugin_toast_233078b3(app.context, inject)
  }

  if (typeof nuxt_plugin_index_8de7eac2 === 'function') {
    await nuxt_plugin_index_8de7eac2(app.context, inject)
  }

  if (typeof nuxt_plugin_modernizr_2916226e === 'function') {
    await nuxt_plugin_modernizr_2916226e(app.context, inject)
  }

  if (typeof nuxt_plugin_polyfill_793e4943 === 'function') {
    await nuxt_plugin_polyfill_793e4943(app.context, inject)
  }

  if (typeof nuxt_plugin_laravelecho_2c4d56a6 === 'function') {
    await nuxt_plugin_laravelecho_2c4d56a6(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_caeab2a8 === 'function') {
    await nuxt_plugin_gtm_caeab2a8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_kactivity_64b222b4 === 'function') {
    await nuxt_plugin_kactivity_64b222b4(app.context, inject)
  }

  if (typeof nuxt_plugin_errorhandler_25db1b11 === 'function') {
    await nuxt_plugin_errorhandler_25db1b11(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetify_e5914fcc === 'function') {
    await nuxt_plugin_vuetify_e5914fcc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_1c07fbd4 === 'function') {
    await nuxt_plugin_plugin_1c07fbd4(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
